import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, dataIt, formatError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { FunzioniDialog } from "@/components/FunzioniDialog";

const STATI = [["prova", "Prova"], ["attivo", "Attivo (abbonato)"], ["attivo_gratuito", "Attivo gratuito"], ["insoluto", "Insoluto"], ["scaduto", "Scaduto"], ["sospeso", "Sospeso"]];
const HEAD = ["Negozio", "Titolare", "Iscritto il", "Fine prova", "Utenti", "Clienti", "Schede", "Accesso", "Stato", "Su misura"];

export default function SuperAdmin() {
  const [items, setItems] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [aperto, setAperto] = useState(null);
  const load = () => api.get("/superadmin/negozi").then((r) => setItems(r.data)).catch((e) => toast.error(formatError(e)));
  useEffect(() => { load(); api.get("/superadmin/funzioni").then((r) => setCatalogo(r.data)).catch(() => {}); }, []);
  const cambia = async (id, stato) => {
    try { await api.patch(`/superadmin/negozi/${id}`, { stato }); toast.success("Stato aggiornato"); load(); } catch (e) { toast.error(formatError(e)); }
  };
  const attivi = items.filter((n) => n.stato === "attivo").length;
  return (
    <div>
      <PageHeader overline="Super amministratore" title="Negozi e abbonamenti">
        <span className="rounded-md bg-white px-3 py-2 text-sm ring-1 ring-slate-200" data-testid="superadmin-riepilogo">{items.length} negozi · {attivi} abbonati · {(attivi * 39).toFixed(0)} €/mese</span>
      </PageHeader>
      <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white shadow-sm">
        <Table data-testid="superadmin-table">
          <TableHeader><TableRow className="bg-slate-50">{HEAD.map((h) => <TableHead key={h} className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{h}</TableHead>)}</TableRow></TableHeader>
          <TableBody>
            {items.map((n) => (
              <TableRow key={n.id} data-testid={`superadmin-row-${n.id}`}>
                <TableCell className="font-semibold">{n.nome}</TableCell>
                <TableCell className="text-xs">{n.owner_email}</TableCell>
                <TableCell>{dataIt(n.created_at?.slice(0, 10))}</TableCell>
                <TableCell>{n.stato === "prova" ? dataIt(n.trial_ends_at?.slice(0, 10)) : "—"}</TableCell>
                <TableCell>{n.utenti}</TableCell><TableCell>{n.clienti}</TableCell><TableCell>{n.schede}</TableCell>
                <TableCell><span className={`text-xs font-bold ${n.attivo ? "text-emerald-700" : "text-rose-600"}`}>{n.attivo ? "Sì" : "Bloccato"}</span></TableCell>
                <TableCell>
                  <Select value={n.stato} onValueChange={(v) => cambia(n.id, v)}>
                    <SelectTrigger className="h-8 w-40" data-testid={`superadmin-stato-${n.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATI.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
                <TableCell>
                  <Button variant="outline" size="sm" onClick={() => setAperto(n)} data-testid={`superadmin-funzioni-${n.id}`}>
                    <Sparkles className="mr-1 h-3.5 w-3.5 text-orange-600" />{n.funzioni?.length ? `${n.funzioni.length} attive` : "Gestisci"}{n.note_personalizzazioni ? " · note" : ""}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <FunzioniDialog negozio={aperto} catalogo={catalogo} onClose={() => setAperto(null)} onSaved={load} />
    </div>
  );
}
